"use client";

import { useEffect } from "react";
import type { PageHeading } from "@/lib/craft/headings";
import { scrollToAnchor } from "@/lib/scroll-to-anchor";

type OnThisPageNavProps = {
  headings: PageHeading[];
  className?: string;
};

export function OnThisPageNav({ headings, className }: OnThisPageNavProps) {
  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (!hash || !headings.some((h) => h.id === hash)) return;
    const timer = window.setTimeout(() => scrollToAnchor(hash), 100);
    return () => window.clearTimeout(timer);
  }, [headings]);

  if (headings.length === 0) return null;

  return (
    <aside className={className ?? "hidden lg:block"}>
      <div className="sticky top-24">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground">
          On this page
        </p>
        <ul className="mt-4 space-y-2 pl-4">
          {headings.map((heading) => (
            <li key={`${heading.id}-${heading.text}`}>
              <a
                href={`#${heading.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToAnchor(heading.id);
                }}
                className={
                  "block text-base leading-snug text-foreground/65 hover:text-primary " +
                  (heading.level === "h3" ? "pl-3 text-sm" : "")
                }
              >
                {heading.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}
